export default __webpack_public_path__ + "static/media/popicon.96e418e7.svg";